import { createAction, props } from '@ngrx/store';

export const setUser = createAction(
  '[Login Page] Login',
  props<{ name: string; token: string; email: string }>(),
);
export const updateToken = createAction('[Login Page] Update token', props<{ token: string }>());
export const removeUser = createAction('[Login Page] Remove');
